var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78.74 75.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.37,75.47l-1.51-1.25C25.72,64.2,16.35,52.82,10,40.38A100.09,100.09,0,0,1,.29,9.05L0,7.1l1.86-.65A113.79,113.79,0,0,1,39.22,0,116.77,116.77,0,0,1,76.87,6.44l1.87.64-.28,2a100.16,100.16,0,0,1-9.74,31.34C62.39,52.81,53,64.2,40.88,74.22ZM5.3,10.32c2.53,15.56,9.15,37.75,34.07,59,24.92-21.21,31.54-43.39,34.07-59A111.28,111.28,0,0,0,39.22,4.76,108.49,108.49,0,0,0,5.3,10.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.77,56.13A12.17,12.17,0,0,1,26.61,44V30.13l15,15h-7A4.3,4.3,0,0,0,43.07,44V27.84a9.42,9.42,0,1,1,7.86,0V44A12.17,12.17,0,0,1,38.77,56.13ZM29,35.87V44a9.78,9.78,0,1,0,19.56,0V26.2l.79-.28a7,7,0,1,0-4.69,0l.8.28V44A6.68,6.68,0,1,1,32.1,44V42.78h3.8ZM47,23.22a3.93,3.93,0,1,1,3.93-3.93A3.93,3.93,0,0,1,47,23.22Zm0-5.48a1.55,1.55,0,1,0,1.55,1.55A1.54,1.54,0,0,0,47,17.74Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSat);
export default __webpack_public_path__ + "static/media/sat.e5cf3d09b6a45c1d03d14c7cb4803871.svg";
export { ForwardRef as ReactComponent };